import { Action } from '@ngrx/store';
import * as mapTypes from './map.types'
import { StreetGeoJson } from './map.interface';


export class FetchStreetGeoJsonRequest implements Action {
    readonly type = mapTypes.FETCH_STREET_GEO_JSON_REQUEST;
    constructor(public id: number) { }
}

export class FetchStreetGeoJsonSuccess implements Action {
    readonly type = mapTypes.FETCH_STREET_GEO_JSON_SUCCESS;
    constructor(public payload: StreetGeoJson) { }
}

export class FetchStreetGeoJsonFailure implements Action {
    readonly type = mapTypes.FETCH_STREET_GEO_JSON_FAILURE;
    constructor(public payload: any) { }
}


// Common

export class UpdateField implements Action {
    readonly type = mapTypes.UPDATE_FIELD;
    public constructor(public field: string, public value: any, public path: string) { }
}

export class SetDefaultData implements Action {
    readonly type = mapTypes.SET_DEFAULT_DATA;
    public constructor(public path: string) { }
}


export type Actions =
    FetchStreetGeoJsonRequest | FetchStreetGeoJsonSuccess | FetchStreetGeoJsonFailure |
    SetDefaultData | UpdateField
